function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57871 11.9643L7.57876 11.9642L16.9304 2.61257C17.135 2.40795 17.25 2.13044 17.25 1.84107C17.25 1.5517 17.135 1.27418 16.9304 1.06957C16.7258 0.864951 16.4483 0.75 16.1589 0.75C15.8696 0.75 15.592 0.864951 15.3874 1.06957L6.77443 9.68257L2.59212 5.85298C2.48759 5.75358 2.36437 5.67591 2.2296 5.62445C2.09395 5.57266 1.94931 5.54848 1.80419 5.55332C1.65906 5.55817 1.51637 5.59195 1.38447 5.65268C1.25257 5.71341 1.13413 5.79987 1.03609 5.90699C0.938056 6.0141 0.862396 6.13972 0.813552 6.27646C0.764708 6.41321 0.743663 6.55833 0.751652 6.70332C0.759641 6.8483 0.796502 6.99024 0.860075 7.12079C0.92322 7.25046 1.01145 7.36631 1.11966 7.46164L6.07096 11.997C6.07097 11.997 6.07098 11.997 6.07099 11.997C6.27813 12.1868 6.55053 12.2894 6.8314 12.2833C7.1123 12.2772 7.38 12.1629 7.57871 11.9643Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5
});

function SvgTickEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickEmpty);
export default __webpack_public_path__ + "static/media/tick-empty.5c8aaad3.svg";
export { ForwardRef as ReactComponent };